import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import TeamTile from 'shared/components/TeamTile';
import ListLoading from 'shared/components/Spinner/ListLoading';

const TeamsList = props => {
  const { teams, loading, included, isButton, onTileClick, showCoaches } = props;

  return (
    <div>
      <ListLoading loading={loading} text='Loading Teams' />
      {!loading && (
      <Row type='flex' gutter={20}>
        {teams.map(e => (
          <Col xs={24} sm={12} md={8} key={e.id}>
            <TeamTile showCoaches={showCoaches} isButton={isButton} included={included} team={e} key={e.id} id={e.id} onClick={onTileClick} />
          </Col>
        ))}
      </Row>
)}
    </div>
  );
};

TeamsList.propTypes = {
  teams: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  included: PropTypes.array.isRequired,
  isButton: PropTypes.bool,
  onTileClick: PropTypes.func,
  showCoaches: PropTypes.bool
};

TeamsList.defaultProps = {
  loading: false,
  isButton: false,
  onTileClick: () => {},
  showCoaches: true
};

export default TeamsList;
